import {
	CaseReducer,
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { STATUS } from '../globalContext/globalContext.interfaces';
import { RootState } from '../store';
import { IFilterAvailableContext } from '../globalContext/filterAvailableContext.interface';


type State = IFilterAvailableContext

export const initialState: State = {
	status: STATUS.idle,
	message: undefined,
	filtros: [],
}

const setFiltersReducer: CaseReducer<State, PayloadAction<Partial<State>>> = (state, action) =>
{
	const {
		filtros
	} = action.payload
	if (filtros)
		state.filtros = filtros
}

export const FiltersAvailableSlice = createSlice({
	name: 'filter',
	initialState,
	reducers: {
		setFiltersAvailable: setFiltersReducer
	}
})

export const selectFiltersAvailable = (state: RootState) => state.FiltersAvailableState;
export const { setFiltersAvailable } = FiltersAvailableSlice.actions;